import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService, UserType } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class BuyerGuard implements CanActivate {
    constructor(private auth: AuthService, private nav: NavController) {}
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        await this.auth.waitForInit();
        if (this.auth.isAuthenticated) {
            if (this.auth.currentAuth.type === UserType.Buyer) {
                return true;
            } else {
                this.nav.navigateForward('/wrong-navigation', { replaceUrl: true });
                return false;
            }
        } else {
            this.nav.navigateRoot('/login', { queryParams: { badauth: true, deeplink: state.url } });
            return false;
        }
    }
}
